import common from '../common';
import Actor from '../physics/Actor';

export default class GoalTile extends THREE.Group {
	constructor() {
		super();

		this._type 			= Actor.TILE;
		this._playing 		= false;
		this._isGoal 		= true;
		this._floorbody 	= null;
		this._animSystem 	= null;
		this._clip 			= null;
		this._action 		= null;
		this._coin 			= null;

		this.init();
	}

	init() {
		const base = common.assets.model('tile_001');

		const matCopy = new THREE.MeshBasicMaterial({
			map: common.assets.texture('omnitrix_floor')
		});

		base.material = matCopy;

		this.add(base);
		const completedLevels = JSON.parse(localStorage.getItem('completed_levels'));

		if (common.levelSettings.unlock.enabled && !(completedLevels && completedLevels[common.currentLevel])) {
			if (common.currentLevel === 1 && common.config.competition_blacklist.includes(common.config.language) || !common.config.competition_enabled) {
				return;
			}

			this.addCoin();
		}
	}

	destroy() {
		console.warn('No destroy method implemented for GoalTile');
	}

	addCoin() {
		const omnitrixObj = common.assets.anim('omnitrix');

		this._coin = omnitrixObj.scene;
		this._clip = omnitrixObj.animations[0];
		this._animSystem = new THREE.AnimationMixer(this._coin);
		this._action = this._animSystem.clipAction(this._clip);

		const texture = common.assets.texture(common.levelSettings.unlock.what);

		texture.center = new THREE.Vector2(0.5, 0.5);
		texture.rotation = 270 * PIXI.DEG_TO_RAD;

		// SkinnedMesh
		this._coin.children[0].children[0].material = new THREE.MeshBasicMaterial({
			map      : texture,
			skinning : true
		});

		this._action.play();
		this._coin.position.y += 0.15;
		this.add(this._coin);
	}

	_getSize(mesh) {
		mesh.updateMatrixWorld(true);

		const bb = new THREE.Box3().setFromObject(mesh);
		const width = bb.max.x - bb.min.x;
		const height = bb.max.y - bb.min.y;
		const depth = bb.max.z - bb.min.z;

		return {
			width  : width,
			height : height,
			depth  : depth
		};
	}

	update() {
		if (this._animSystem) {
			this._animSystem.update(P3.Ticker.dt * this._animSystem.timeScale);
		}
	}

	startAnim() {
		if (this._action) {
			this._action.play();
		}
	}

	stopAnim() {
		if (this._action) {
			this._action.stop();
		}
	}

	playOnce() {
		if (this._playing || !this._action) {
			return;
		}

		this._playing = true;
		this._action.setLoop(THREE.LoopOnce, 1);
		this._action.play();

		P3.utils.delay(this._clip.duration, () => {
			this._action.setLoop(THREE.LoopRepeat, Infinity);
			this._action.stop();
			this._playing = false;
		}, this);
	}

	get activated() {
		return this._activated;
	}

	get type() {
		return this._type;
	}

	get isGoal() {
		return true;
	}

	set activated(v) {
		this._activated = v;
	}

	set type(v) {
		this._type = v;
	}

	get coin() {
		return this._coin;
	}

	set coin(v) {
		this._coin = v;
	}
}
